import { render, staticRenderFns } from "./classAttendance.vue?vue&type=template&id=2f122931"
import script from "../../services/attendance/class-attendance.js?vue&type=script&lang=js&external"
export * from "../../services/attendance/class-attendance.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports